import React from 'react'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Icon from '@material-ui/core/Icon'
import Divider from '@material-ui/core/Divider'

import { DeviceContext } from '../contexts/deviceContext'
import { CameraContext } from '../contexts/cameraContext'

import '../styles/main-header.scss'
import logoImage from '../images/landing-page/logo3.svg'
import * as tfvis from '@tensorflow/tfjs-vis'

export default function MainHeader(props) {
    const deviceContext = React.useContext(DeviceContext)
    const cameraContext = React.useContext(CameraContext)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const { owner, email } = deviceContext

    function rendeHeader() {
        return (
            <div className="main-header">
                <img
                    width={324}
                    height={40}
                    src={logoImage}
                    onClick={() => {
                        window.eventManager.sendEngagementBehavior('logo')
                    }}
                />
                <div
                    className={classnames('nav-item', {
                        active: true,
                    })}
                    onClick={() => {
                        window.eventManager.sendEngagementBehavior('camera')
                    }}
                >
                    <Icon className="nav-item__icon">videocam</Icon>
                    <span className="nav-item__text">
                        <FormattedMessage id="local_camera" />
                    </span>
                </div>

                <div
                    className="nav-item"
                    onClick={(e) => {
                        window.open('https://alfredcamera.zendesk.com/hc')
                        window.eventManager.sendEngagementBehavior('faq')
                    }}
                >
                    <Icon className="nav-item__icon">help</Icon>
                    <span className="nav-item__text">
                        <FormattedMessage id="FAQ" />
                    </span>
                </div>
                {window.alfredTest2wsxsw2 ? (
                    <div className="nav-item" onClick={props.openTestPanel}>
                        <span className="nav-item__text">DEBUG</span>
                    </div>
                ) : (
                    ''
                )}
                {window.alfredTest2wsxsw2 ? (
                    <div
                        className="nav-item"
                        onClick={() => {
                            tfvis.visor().open()
                        }}
                    >
                        <span className="nav-item__text">PROFILER</span>
                    </div>
                ) : (
                    ''
                )}
                <div
                    className="avatar"
                    onClick={(e) => {
                        handleClick(e)
                        window.eventManager.sendEngagementBehavior('account')
                    }}
                >
                    <img
                        className="avatar__image"
                        src={owner.picture}
                        alt="avatar"
                        width="40"
                        height="40"
                    />
                </div>
                <Menu
                    id="accountMenu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => handleClick(false)}
                >
                    <ListItem
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            return false
                        }}
                    >
                        <div className="user-info">
                            <div className="avatar">
                                <img
                                    className="avatar__image"
                                    src={owner.picture}
                                    alt="avatar"
                                    width="40"
                                    height="40"
                                />
                            </div>
                            <div className="user-detail">
                                <p className="user-name">{owner.name}</p>
                                <p className="user-email">{email}</p>
                            </div>
                        </div>
                    </ListItem>
                    <Divider />
                    <MenuItem
                        onClick={(e) =>
                            window.open(
                                'https://alfred.camera/legal/terms-of-service'
                            )
                        }
                    >
                        <ListItemIcon>
                            <Icon>description</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="TermsofService" />
                        </span>
                    </MenuItem>
                    <MenuItem
                        onClick={(e) =>
                            window.open(
                                'https://alfred.camera/legal/privacy-policy'
                            )
                        }
                    >
                        <ListItemIcon>
                            <Icon>description</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="PrivatePolicy" />
                        </span>
                    </MenuItem>
                    <MenuItem
                        onClick={(e) =>
                            window.open(
                                'https://alfred.camera/userfeedback/tech_web'
                            )
                        }
                    >
                        <ListItemIcon>
                            <Icon>email</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="contactUs" />
                        </span>
                    </MenuItem>
                    <Divider />
                    <MenuItem
                        onClick={() => {
                            deviceContext.mutations.signOut()
                            cameraContext.mutations.resetState()
                        }}
                    >
                        <ListItemIcon>
                            <Icon>exit_to_app</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="signOut" />
                        </span>
                    </MenuItem>
                </Menu>
            </div>
        )
    }

    return <>{rendeHeader()}</>
}
